<template>
  <loading-charts v-if="loadingData" class="loading-charts"/>
  <table-filter 
    :filterByAccountNo="true" 
    :filterByShipmentID="true"
    :filterByRouteCode="true"
  @filterValues="filterValues($event)"/>

  <!-- <open-search-table-filter 
        :useQueuedActivityFilter="true"
        :filterByAccountNo="true" 
        :filterByShipmentID="true"
        :filterByCompanyName="true" 
        :filterByRouteCode="true"
        :filterBySearchAll="true"
        :hideDateRange="true"
        @filterValuesOpenSearch="filterValuesOpenSearch($event)"/> -->
  <div class="table-container-main">
    <div class="responsive-table">
        <!-- <div class="table-header" id="header">
            <div class="col-1">Shipment ID</div>
            <div class="col-2">Activity Time</div>
            <div class="col-3">Code</div>
            <div class="col-4">Route</div>
        </div> -->
        <div class="table-header" id="header">
            <div class="col-1 sortable" @click="sortBy('shipmentID')">
                Shipment ID
                <span v-if="sortKey === 'shipmentID'">
                {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
            </div>

            <div class="col-2 sortable" @click="sortBy('activityTime')">
                Activity Time
                <span v-if="sortKey === 'activityTime'">
                {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
            </div>

            <div class="col-3 sortable" @click="sortBy('code')">
                Code
                <span v-if="sortKey === 'code'">
                {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
            </div>

            <div class="col-3 sortable" @click="sortBy('routeCode')">
                Route
                <span v-if="sortKey === 'routeCode'">
                {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
            </div>
        </div>
        <loading-charts v-if="loadingTable" class="loading-charts"/>
        <div v-if="sortedQueuedShipmentActivity.length > 0" class="table-row-container">
            <div class="table-row" v-for="(shipment, index) in sortedQueuedShipmentActivity" :key="index">
                <div @click="trackShipment(shipment.shipmentID)" class="col-1"><p class="shipmentid-text" id="shipmentid-text">{{shipment.shipmentID}}</p></div>
                <div class="col-2 col-data">{{formatLocalTime(shipment.queuedActivity.activityTime)}}</div>
                <div class="col-3 col-data"><p class="service-text">{{shipment.queuedActivity.code}}</p></div>
                <div class="col-4">{{shipment?.routeCode}}</div>
            </div>
        </div>
        <div v-if="(sortedQueuedShipmentActivity.length == 0)" class="table-row-container">
            <div class="table-row">
                <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                <div class="col-2 col-data">No Shipments</div>
                <div class="col-3 col-data"><p class="service-text"></p></div>
                <div class="col-4"></div>
            </div>
        </div>
    </div>
  </div>
  <div class="button-container">
    <div class="print-selected close-label">
        <p class="print-selected-text download-csv" @click="downloadCSVTest()">Download CSV</p>
    </div>
  </div>
  

<queued-activity-shipment-info v-if="toggleTrackShipment" @closeShipmentInfo="closeShipmentInfo($event)" :trackShipmentID="trackShipmentID" :cognitoUser="cognitoUser" :jwtToken="jwtToken" :userData="userData"/>
<alert-user v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API} from 'aws-amplify';
import QueuedActivityShipmentInfo from './QueuedActivityShipmentInfo.vue'
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue'
import TableFilter from './../TableFilter.vue'
import AlertUser from '../../Popups/AlertUser.vue';
import jsonexport from 'jsonexport'
// import OpenSearchTableFilter from '../OpenSearchTableFilter.vue'

export default {
    components:{
        QueuedActivityShipmentInfo,
        LoadingCharts,
        TableFilter,
        // OpenSearchTableFilter,
        AlertUser
    },
    props: ['selectedShipment', 'selectedDates', 'userData', 'jwtToken', 'cognitoUser', 'selectedAccountNo', 'filterByRoute'],
    mounted(){
        if(this.filterByRoute){
            let event = {
                filterField: 'routeCode',
                filterValue: this.filterByRoute
            }
            this.filterValues(event);
        }else{
            this.listQueuedActivities()
        }
    },
    data(){
        return{
            queuedShipmentActivity: [],
            inTransitShipments: [],
            deliveredShipments: [],
            CurrentKey: null,
            trackShipmentID: null,
            toggleTrackShipment: false,
            user: null,
            fromDate: null,
            toDate: null,
            sliderValue: null,
            selectedShipmentArray: [],
            labelData: null,
            loadingData: false,
            loadingTable: false,
            isFiltered: false,
            filterField: '',
            filterValue: '',
            toggleAlertBox: '',
            alertMessage: '',
            previousMonth: '',
            currentMonth: '',
            sortKey: null,
            sortDirection: 'asc',
            items: `items{
                    shipmentID
                    service
                    username
                    accountNo
                    ref1
                    description
                    deliveryInstructions
                    serviceAddress{
                        address{
                        companyName
                        address1
                        city
                        state
                        zipCode
                        }
                    }
                    deliveryPickup{
                        address{
                        companyName
                        address1
                        city
                        state
                        zipCode
                        }
                    }
                    notify{
                        delivery{
                        phone
                        email
                        }
                        nonDelivery{
                        phone
                        email
                        }
                    }
                    additionalServices
                }`
        }
    },
    computed: {
        sortedQueuedShipmentActivity() {
            if (!this.sortKey) return this.queuedShipmentActivity;

            const getSortValue = (item, key) => {
                if (key === "activityTime") {
                    return item.queuedActivity?.activityTime || "";
                }

                if (key === "code") {
                    return item.queuedActivity?.code || "";
                }

                return item[key] || "";
            };

            return [...this.queuedShipmentActivity].sort((a, b) => {
                const aVal = getSortValue(a, this.sortKey);
                const bVal = getSortValue(b, this.sortKey);

                if (this.sortKey === "activityTime") {
                    const aTime = aVal ? Date.parse(aVal) : 0;
                    const bTime = bVal ? Date.parse(bVal) : 0;

                    return this.sortDirection === "asc"
                        ? aTime - bTime
                        : bTime - aTime;
                }

                const valA = String(aVal || "").toLowerCase().trim();
                const valB = String(bVal || "").toLowerCase().trim();

                if (valA < valB) return this.sortDirection === "asc" ? -1 : 1;
                if (valA > valB) return this.sortDirection === "asc" ? 1 : -1;
                return 0;
            });
        }
    },
    methods:{
        sortBy(key) {
            console.log(key)
            if (this.sortKey === key) {
                // Toggle direction
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortKey = key;
                this.sortDirection = 'asc';
            }
        },
        async filterValuesOpenSearch(event){
            console.log(event)
            this.loadingTable = true;
            const baseFilter = (event?.input?.filter) ?? {};

            this.queuedShipmentActivity = [];
            let cursor = null;
            let safeguard = 0; // Prevent crazy large amounts of calls

            do {
                let finalEvent = {
                    ...event,
                    input: {
                        ...event.input,
                        ...(cursor ? { searchAfter: Array.isArray(cursor) ? JSON.stringify(cursor) : cursor } : {}),
                        filter: {
                            ...baseFilter,
                            // exists: 'currentKey',
                            //username: this.userData.userName,
                            //accountNo: this.userData.accountNo
                        }
                    }
                };

                const { queuedShipmentActivity, searchAfterValue, searchAfterJSON } =
                await this.queryOpenSearchFilterFunction(finalEvent);

                if (Array.isArray(queuedShipmentActivity) && queuedShipmentActivity.length) {
                    const parsedArray = queuedShipmentActivity.map(item => JSON.parse(item));
                    this.queuedShipmentActivity.push(...parsedArray);
                }

                let next = searchAfterValue;
                if (!next && typeof searchAfterJSON === 'string') {
                    try { next = JSON.parse(searchAfterJSON); } catch { next = []; }
                }

                // stop when Lambda signals no more pages
                if (!Array.isArray(next) || next.length === 0) break;

                cursor = next;
            } while (++safeguard < 100);
            console.log(this.queuedShipmentActivity)
            this.loadingTable = false;
        },
        async queryOpenSearchFilterFunction(input) {
            this.loadingData = true;
            try {
                const { data } = await API.graphql({
                    query: `
                        mutation queryOpenSearchFilter($input: SearchInput!) {
                        queryOpenSearchFilter(input: $input) {
                                searchAfterValue
                                filterResult
                            }
                        }
                    `,
                    variables: input,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                if (Array.isArray(data.errors) && data.errors.length) {
                    const msg = data.errors.map(e => e.message).join(" | ");
                    if (msg.includes("Response payload size exceeded")) {
                        this.toggleAlertBox = true;
                        this.alertMessage =
                        "Too many results to return at once. Please narrow your filters.";
                        return [];
                    }
                    // Other Error in request
                    this.toggleAlertBox = true;
                    this.alertMessage = msg || "Error in request.";
                    return [];
                }

                const accountItems = data?.queryOpenSearchFilter?.filterResult ?? [];
                const searchAfter = data?.queryOpenSearchFilter?.searchAfterValue ?? [];

                return{
                    queuedShipmentActivity: accountItems,
                    searchAfterJSON: searchAfter
                }
            } catch (err) {
                console.log(err);
                const msg =
                    err?.errors?.[0]?.message || err?.message || String(err || "");
                    if (msg.includes("Response payload size exceeded")) {
                    this.toggleAlertBox = true;
                    this.alertMessage =
                        "Too many results to return at once. Please narrow your filters.";
                    return [];
                }
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting filtered shipments";
                return [];
            } finally {
                this.loadingData = false;
            }
        },
        // filterValues(event){
        //     this.isFiltered = true;
        //     this.filterField = event.filterField;
        //     this.filterValue = event.filterValue;
        //     switch (event.filterField) {
        //         case "shipmentID":
        //             this.filterQueuedActivities();
        //             this.isFiltered = false;
        //             break;
        //         case "accountNo":
        //             this.filterQueuedActivities();
        //             this.isFiltered = false;
        //             break;
        //         case "routeCode":
        //             this.filterQueuedActivities();
        //             this.isFiltered = false;
        //             break;
        //         default:
        //             this.listQueuedActivities();
        //             this.isFiltered = false;
        //             break;
        //     }
        // },
        filterValues(event) {
            this.isFiltered = true;
            this.filterField = event.filterField;
            this.filterValue = event.filterValue;

            if (["shipmentID", "accountNo", "routeCode"].includes(event.filterField)) {
                this.filterQueuedActivities();
            } else {
                this.listQueuedActivities();
            }
        },
        // async filterQueuedActivities(){
        //     this.loadingTable = true;
        //     this.queuedShipmentActivity = [];
            
        //     try{
        //         let filterQueuedActivitiesItems = await API.graphql({
        //         query:  `query getQueuedShipment {
        //             getQueuedShipment(shipmentID: "${this.filterValue}") {
        //                 shipmentID
        //                 queuedActivity {
        //                     activityTime
        //                     code
        //                 }
        //             }
        //         }`,
        //         authMode: "AMAZON_COGNITO_USER_POOLS",
        //         })
        //         console.log(filterQueuedActivitiesItems)
        //         //this.queuedShipmentActivity = filterQueuedActivitiesItems.data.getQueuedShipment;
        //         if(filterQueuedActivitiesItems.data.getQueuedShipment == null){
        //             this.queuedShipmentActivity = []
        //             return;
        //         }
        //         this.queuedShipmentActivity.push(filterQueuedActivitiesItems.data.getQueuedShipment)
        //     }catch(e){
        //         if(e){
        //             this.toggleAlertBox = true;
        //             this.alertMessage = "Error getting queued activities"
        //         }
        //     }finally{
        //         this.loadingTable = false;
        //         this.isFiltered = false;
        //     }
        // },
        async filterQueuedActivities() {
            this.loadingTable = true;
            this.queuedShipmentActivity = [];

            try {
                if (this.filterField === "shipmentID") {
                    const result = await API.graphql({
                        query: `
                            query getQueuedShipment{
                                getQueuedShipment(shipmentID: "${this.filterValue}") {
                                    shipmentID
                                    accountNo
                                    routeCode
                                    queuedActivity {
                                        activityTime
                                        code
                                    }
                                }
                            }
                        `,
                        variables: {
                            shipmentID: this.filterValue
                        },
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                    });

                    const item = result.data.getQueuedShipment;
                    this.queuedShipmentActivity = item ? [item] : [];
                    return;
                }

                let allItems = [];
                let nextToken = null;

                do {
                    const result = await API.graphql({
                        query: `
                            query listQueuedShipments($nextToken: String) {
                                listQueuedShipments(limit: 1000, nextToken: $nextToken) {
                                    items {
                                        shipmentID
                                        accountNo
                                        routeCode
                                        queuedActivity {
                                            activityTime
                                            code
                                        }
                                    }
                                    nextToken
                                }
                            }
                        `,
                        variables: {
                            nextToken
                        },
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                    });

                    const response = result.data.listQueuedShipments;

                    allItems = allItems.concat(response.items || []);
                    nextToken = response.nextToken;

                } while (nextToken);

                this.queuedShipmentActivity = allItems.filter(item => {
                    const fieldValue = String(item[this.filterField] || "").toLowerCase().trim();
                    const filterValue = String(this.filterValue || "").toLowerCase().trim();

                    if (this.filterField === "routeCode") {
                        return fieldValue === filterValue;
                    }

                    return fieldValue.includes(filterValue);
                });

            } catch (e) {
                console.error(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting queued activities";
            } finally {
                this.loadingTable = false;
                this.isFiltered = false;
            }
        },
        async listQueuedActivities(){
            this.loadingTable = true;
            this.queuedShipmentActivity = [];
            
            try{
                let listQueuedActivitiesItems = await API.graphql({
                query:  `query listQueuedShipments {
                    listQueuedShipments {
                        items {
                            shipmentID
                            routeCode
                            accountNo
                            queuedActivity {
                                activityTime
                                code
                            }
                        }
                    }
                }`,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                
                this.queuedShipmentActivity = listQueuedActivitiesItems.data.listQueuedShipments.items;
            }catch(e){
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting queued activities"
                }
            }finally{
                this.loadingTable = false;
                this.isFiltered = false;
            }
        },
        formatLocalTime(utcDate) {
            const date = new Date(utcDate);

            const formattedDate = date.toLocaleString('en-US', {
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: true,
                timeZone: 'UTC'
            });

            console.log(formattedDate);
            return formattedDate;
        },
        trackShipment(shipmentID){
            this.toggleTrackShipment = true;
            this.trackShipmentID = shipmentID;
        },
        closeShipmentInfo(event){
            this.toggleTrackShipment = event;
            if(this.filterByRoute){
                let event = {
                    filterField: 'routeCode',
                    filterValue: this.filterByRoute
                }
                this.filterValues(event);
            }else{
                this.listQueuedActivities()
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async downloadCSVTest() {
            this.loadingTable = true;

            try {
                const csvArray = this.sortedQueuedShipmentActivity.map(shipment => ({
                    shipmentID: shipment.shipmentID,
                    accountNo: shipment.accountNo,
                    routeCode: shipment.routeCode,
                    code: shipment.queuedActivity?.code,
                    activityTime: shipment.queuedActivity?.activityTime
                }));

                jsonexport(csvArray, (error, csv) => {
                    if (error) {
                        this.toggleAlertBox = true;
                        this.alertMessage = "Error downloading queued activities";
                        return;
                    }

                    const blob = new Blob([csv], { type: 'text/csv' });
                    const anchor = document.createElement('a');

                    anchor.href = window.URL.createObjectURL(blob);
                    anchor.download = 'QueuedActivities.csv';
                    anchor.click();

                    window.URL.revokeObjectURL(anchor.href);
                    anchor.remove();
                });

            } finally {
                this.loadingTable = false;
            }
        }
    }
}
</script>

<style scoped>
h3{
    margin: 0;
}
.table-container-main{
    width: 100%;
    margin-top: 0;
    overflow-x: hidden;
}

.responsive-table{
    width: 100%;
}

* {
    scrollbar-width: auto;
    scrollbar-color: #f3f3f3 #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
    width: 16px;
}

*::-webkit-scrollbar-track {
    background: #ffffff;
}

*::-webkit-scrollbar-thumb {
    background-color: #f3f3f3;
    border-radius: 10px;
    border: 3px solid #ffffff;
}

.table-header{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #32ccfe;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
    /* width: calc(100% - 20px); */
    color: #fff;
}

.table-row-container{
    max-height: 350px;
    overflow-y: auto;
    border-radius: 5px;
    width: 100%;
    animation: animate-table-row 1s ease;
}

@keyframes animate-table-row{
    from{
        margin-left: -50px;
    }
    to{
        margin-left: 0px;
    }
}

.table-row{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #f3f3f3;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
    /* width: calc(100% - 20px); */
}

.table-header .col-1{
    margin-right: 5px;
}

.col-1{
    flex-basis: 20%;
    text-align: left;
    white-space: nowrap;
}

.col-2{
    flex-basis: 40%;
    text-align: left;
    margin-left: 5px;
}

.col-3{
    flex-basis: 30%;
    text-align: left;
    margin-left: 5px;
}

.col-data{
    text-align: left;
}

.col-4{
    flex-basis: 10%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.service-text{
    background-color: #d4d4d4;
    padding: 2.5px 10px;
    border-radius: 999px;
    width: fit-content;
    margin: 0;
    font-size: 12px;
}

.shipmentid-text{
    margin: 0;
    color: #6a6a6a;
    width: fit-content;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
    transition-duration: .5s;
}

.shipmentid-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

input[type="checkbox"] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    /* Remove most all native input styles */
    appearance: none;
    /* For iOS < 15 */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;
    cursor: pointer;

    font: inherit;
    color: #33f18a;
    width: 1.05em;
    height: 1.05em;
    border: 0.15em solid #33f18a;
    border-radius: 0.15em;
    /* transform: translateY(-0.075em); */

    display: grid;
    place-content: center;
    transition-duration: .5s;
}

input[type="checkbox"]:hover{
    background-color: #f3f3f3;
    transition-duration: .5s;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: CanvasText;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

.button-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin: 0;
    animation: animate-table-row 1s ease;
}

.print-selected-text{
    margin: 0;
    margin-bottom: 5px;
    margin-right: 5px;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
    transition-duration: .5s;
}

.download-csv{
    margin-top: 5px;
}

.void-selected-text{
    margin: 0;
    margin-bottom: 5px;
    padding: 2.5px 10px;
    margin-bottom: 5px;
    border-radius: 999px;
    background-color: #fe804d;
    border: 1px solid #ff5512;
    color: #fff;
    transition-duration: .5s;
}

.print-selected-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

.void-selected-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

.close-label{
    margin-left: auto;
}

.label-container{
    width: 100%;
}

@media only screen and (max-width: 600px) {
    .service-text{
        font-size: 8px;
    }
}

@media only screen and (max-width: 1135px) {
   .col-1{
        min-width: 30%;
    }
}
</style>